import { string, shape, number, bool, arrayOf } from 'prop-types';

const foodBasicPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
};

const supplierFoodTypePropTypes = {
  id: number.isRequired,
  supplierId: number.isRequired,
  foodId: number.isRequired,
  food: shape(foodBasicPropTypes).isRequired,
  cost: number.isRequired,
};

const businessPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  businessTaxId: string.isRequired,
  phone: string,
  email: string,
};

const locationPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  address: string.isRequired,
  cityId: number,
};

const supplierPropTypes = {
  id: number.isRequired,
  businessId: number.isRequired,
  business: shape(businessPropTypes).isRequired,
  locationId: number.isRequired,
  location: shape(locationPropTypes).isRequired,
  billingType: string.isRequired,
  type: string,
  creditTime: string.isRequired,
  bankAccountNumber: string,
  active: bool.isRequired,
  supplierFoodTypeList: arrayOf(shape(supplierFoodTypePropTypes)),
};

export default supplierPropTypes;
